import { __assign } from "tslib";
import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { isLinkItem } from '../utils/utils';
import styles from './styles.css.js';
import Tooltip from '../tooltip';
import { getItemTarget } from '../utils/utils';
import useHiddenDescription from '../utils/use-hidden-description';
import InternalIcon from '../../icon/internal';
import { useDropdownContext } from '../../internal/components/dropdown/context';
var ItemElement = function (_a) {
    var _b;
    var item = _a.item, disabled = _a.disabled, onItemActivate = _a.onItemActivate, highlighted = _a.highlighted, highlightItem = _a.highlightItem, _c = _a.first, first = _c === void 0 ? false : _c, last = _a.last, hasCategoryHeader = _a.hasCategoryHeader, _d = _a.variant, variant = _d === void 0 ? 'normal' : _d;
    var isLink = isLinkItem(item);
    var onClick = function (event) {
        if (!isLink) {
            event.preventDefault();
        }
        if (!disabled) {
            onItemActivate(item, event);
        }
    };
    var onHover = function (event) {
        event.preventDefault();
        highlightItem(item);
    };
    return (React.createElement("li", { className: clsx(styles['item-element'], styles["variant-" + variant], (_b = {},
            _b[styles.highlighted] = highlighted,
            _b[styles.disabled] = disabled,
            _b[styles.first] = first,
            _b[styles.last] = last,
            _b[styles['has-category-header']] = hasCategoryHeader,
            _b)), role: "presentation", "data-testid": item.id, "data-description": item.description, onClick: onClick, onMouseEnter: onHover, onTouchStart: onHover },
        React.createElement(MenuItem, { item: item, disabled: disabled, highlighted: highlighted })));
};
function MenuItem(_a) {
    var item = _a.item, disabled = _a.disabled, highlighted = _a.highlighted;
    var menuItemRef = useRef(null);
    var _b = useHiddenDescription(item.disabledReason), targetProps = _b.targetProps, descriptionEl = _b.descriptionEl;
    useEffect(function () {
        if (highlighted && menuItemRef.current) {
            menuItemRef.current.focus();
        }
    }, [highlighted]);
    var hasTooltip = disabled && item.disabledReason;
    var menuItemProps = __assign({ className: styles['menu-item'], ref: menuItemRef, role: 'menuitem', 'aria-disabled': disabled ? 'true' : undefined, tabIndex: highlighted ? 0 : -1 }, (hasTooltip ? targetProps : {}));
    var menuItem = isLinkItem(item) ? (React.createElement("a", __assign({}, menuItemProps, { href: !disabled ? item.href : undefined, target: getItemTarget(item), rel: item.external ? 'noopener noreferrer' : undefined }),
        React.createElement(MenuItemContent, { item: item, disabled: disabled }))) : (React.createElement("span", __assign({}, menuItemProps),
        React.createElement(MenuItemContent, { item: item, disabled: disabled })));
    var position = useDropdownContext().position;
    var tooltipPosition = position === 'bottom-left' || position === 'top-left' ? 'left' : 'right';
    return hasTooltip ? (React.createElement(Tooltip, { content: item.disabledReason, position: tooltipPosition },
        menuItem,
        descriptionEl)) : (menuItem);
}
var MenuItemContent = function (_a) {
    var item = _a.item, disabled = _a.disabled;
    var hasIcon = !!(item.iconName || item.iconUrl || item.iconSvg);
    var hasExternal = isLinkItem(item) && item.external;
    return (React.createElement(React.Fragment, null,
        hasIcon && React.createElement(MenuItemIcon, { name: item.iconName, url: item.iconUrl, svg: item.iconSvg, alt: item.iconAlt }),
        ' ',
        item.text,
        " ",
        hasExternal && React.createElement(ExternalIcon, { disabled: disabled, ariaLabel: item.externalIconAriaLabel })));
};
var MenuItemIcon = function (props) { return (React.createElement("span", { className: styles.icon },
    React.createElement(InternalIcon, __assign({}, props)))); };
var ExternalIcon = function (_a) {
    var disabled = _a.disabled, ariaLabel = _a.ariaLabel;
    var icon = React.createElement(InternalIcon, { variant: disabled ? 'disabled' : 'normal', name: "external" });
    return (React.createElement("span", { className: styles['external-icon'], role: ariaLabel ? 'img' : undefined, "aria-label": ariaLabel }, icon));
};
export default ItemElement;
